import React from "react";
import styled from "styled-components";
export const EditorCont = styled.div`
  margin: 20px;
  padding: 20px;
  border: 1px solid lightgray;
`;
